import script from "./EndpointBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./EndpointBlock.vue?vue&type=script&setup=true&lang=js"

import "./EndpointBlock.vue?vue&type=style&index=0&id=709087c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709087c8"]])

export default __exports__